export default __webpack_public_path__ + "static/media/dumpster-small.0f9478c7.svg";